import { render } from "./CopyCatalogToStores.vue?vue&type=template&id=6631b821"
import script from "./CopyCatalogToStores.vue?vue&type=script&lang=js"
export * from "./CopyCatalogToStores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__